var path = '/formViewer/component/functionButton/functionButtonPlaceholder.tpl.html';
var html = "<ui-function-button class=\"fieldListComponent\"\n                    field-structure=\"fieldStructure\"\n                    ui-show-field-details-modal></ui-function-button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;